import React from 'react'
import ReactGA from 'react-ga'
import styled from 'styled-components'
import Header from './header'

const Container = styled.div``
const Unaudited = styled.div`
  text-align: center;
  color: red;
  font-size: 14px;
  padding: 5px 0;
`
const BackButton = styled.a`
  color: #148e9e;
  text-decoration: none;
`
const DataLayout = ({ children, year }) => {
  ReactGA.pageview(window.location.pathname + window.location.search)
  return (
    <Container>
      <BackButton href="/">&lt; HOME</BackButton>
      {year == '2024' && <Unaudited>2024 Unaudited</Unaudited>}
      <Header />
      {children}
    </Container>
  )
}

export default DataLayout
